import { MAX_STARTERS_FOR_AUTO_RELOAD_PLAYER } from '@racemap/utilities/consts/reload';
import { useIsPageVisible } from 'src/lib/customHooks/useIsPageVisible';
import { reduceEndTime } from '../selectors';
import { useStore } from '../store';
import { correctedNow } from './clock';

/**
 * Determines whether auto-reload functionality should be enabled for the player.
 *
 * Auto-reload is enabled when all of the following conditions are true:
 * - Auto-reload is enabled in the first event's options
 * - The page is currently visible
 * - The event has not ended
 * - The number of starters does not exceed the maximum threshold for auto-reload
 *
 * @returns {boolean} `true` if auto-reload should be enabled, `false` otherwise
 */
export function useAutoReloadIsEnabled(): boolean {
  const reloadInterval = useStore((state) => state.events.at(0)?.options.reloadInterval ?? 0);
  const starterCount = useStore((state) =>
    state.events.reduce((sum, ev) => sum + ev.starters.length, 0),
  );
  const isEventOver = useStore((state) => reduceEndTime(state.events) < correctedNow());
  const pageVisible = useIsPageVisible();

  return (
    reloadInterval > 0 &&
    pageVisible &&
    !isEventOver &&
    starterCount <= MAX_STARTERS_FOR_AUTO_RELOAD_PLAYER
  );
}
